import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const AgentReports = () => import('./AgentReports.vue');
const LabelReports = () => import('./LabelReports.vue');
const InboxReports = () => import('./InboxReports.vue');
const TeamReports = () => import('./TeamReports.vue');
const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const AdvancedMonitoring = () => import('./AdvancedMonitoring.vue');
const SLAReports = () => import('./SLAReports.vue');
const TicketMetricsReports = () => import('./TicketMetricsReports.vue');
const Dashboard = () => import('./Dashboard.vue');
const ReportBuilder = () => import('./ReportBuilder.vue');
const NewCreateModeReport = () =>
  import('../newReports/components/NewCreateModeReport.vue');
const NewExternalReport = () =>
  import('../newReports/components/NewExternalReport.vue');
const ClaudiaMetricasLegado = () => import('./ClaudiaMetricasLegado.vue');

// Every Omni dashboard report shares the same wrapper + NewExternalReport
// iframe; only the header, icon, path, route name and dashboard id differ.
// This factory keeps those declarations DRY (and avoids duplicated blocks).
const omniReportRoute = ({
  headerTitle,
  icon,
  path,
  name,
  embeddingDesignation,
}) => ({
  path: frontendURL('accounts/:accountId/reports'),
  component: SettingsContent,
  props: { headerTitle, icon, keepAlive: false },
  children: [
    {
      path,
      name,
      meta: { permissions: ['administrator', 'report_manage'] },
      component: NewExternalReport,
      props: { embeddingDesignation },
    },
  ],
});

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'overview',
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'ADVANCED_MONITORING.HEADER',
        icon: 'data-histogram',
        keepAlive: false,
      },
      children: [
        {
          path: 'overview-2',
          name: 'advanced_monitoring',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AdvancedMonitoring,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Index,
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'REPORT.HEADER',
      icon: 'chat',
      path: 'conversations-omni',
      name: 'omni_conversations_report',
      embeddingDesignation: 'dashboard.conversations',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_GENERAL_INFO_REPORTS.HEADER',
      icon: 'cloud',
      path: 'claudia-general-info-omni',
      name: 'omni_claudia_general_info_report',
      embeddingDesignation: 'dashboard.claudia_general_info',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_CONTROLLED_FLOWS_REPORTS.HEADER',
      icon: 'cloud',
      path: 'claudia-controlled-flows-omni',
      name: 'omni_claudia_controlled_flows_report',
      embeddingDesignation: 'dashboard.claudia_controlled_flows',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_QUALITY_REPORTS.HEADER',
      icon: 'star-emphasis',
      path: 'claudia-quality-omni',
      name: 'omni_claudia_quality_report',
      embeddingDesignation: 'dashboard.claudia_quality',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_TAGS_TOPICS_REPORTS.HEADER',
      icon: 'tag',
      path: 'claudia-tags-topics-omni',
      name: 'omni_claudia_tags_topics_report',
      embeddingDesignation: 'dashboard.claudia_tags_topics',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_CONTENTS_REPORTS.HEADER',
      icon: 'library',
      path: 'claudia-contents-omni',
      name: 'omni_claudia_contents_report',
      embeddingDesignation: 'dashboard.claudia_contents',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_AGENTIC_REPORTS.HEADER',
      icon: 'sparkle',
      path: 'claudia-agentic-omni',
      name: 'omni_claudia_agentic_report',
      embeddingDesignation: 'dashboard.claudia_agentic',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_AUDIT_REPORTS.HEADER',
      icon: 'search-check',
      path: 'claudia-audit-omni',
      name: 'omni_claudia_audit_report',
      embeddingDesignation: 'dashboard.claudia_audit',
    }),
    omniReportRoute({
      headerTitle: 'CLAUDIA_OTHER_INDICATORS_REPORTS.HEADER',
      icon: 'more-horizontal',
      path: 'claudia-other-indicators-omni',
      name: 'omni_claudia_other_indicators_report',
      embeddingDesignation: 'dashboard.claudia_other_indicators',
    }),
    {
      // Legacy Metabase dashboard embedded via a backend-signed JWT (not Explo,
      // not Omni). It renders its own header (with the project selector on the
      // right) + a full-bleed iframe, so it bypasses the shared SettingsContent
      // wrapper instead of nesting under it.
      path: frontendURL('accounts/:accountId/reports/claudia-metricas-legado'),
      name: 'claudia_metricas_legado_report',
      meta: {
        permissions: ['administrator', 'report_manage'],
      },
      component: ClaudiaMetricasLegado,
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SERVICE_TIME_METRICS_REPORTS.HEADER',
        icon: 'alarm',
        keepAlive: false,
      },
      children: [
        {
          path: 'service-time-metrics',
          name: 'service_time_metrics_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Dashboard,
          props: { embeddingDesignation: 'dashboard.service_time_metrics' },
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'SERVICE_TIME_METRICS_REPORTS.HEADER',
      icon: 'alarm',
      path: 'service-time-metrics-omni',
      name: 'omni_service_time_metrics_report',
      embeddingDesignation: 'dashboard.service_time_metrics',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN_METRICS_REPORTS.HEADER',
        icon: 'megaphone',
      },
      children: [
        {
          path: 'campaign-metrics',
          name: 'campaign_metrics_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Dashboard,
          props: { embeddingDesignation: 'dashboard.campaign_metrics' },
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'CAMPAIGN_METRICS_REPORTS.HEADER',
      icon: 'megaphone',
      path: 'campaign-metrics-omni',
      name: 'omni_campaign_metrics_report',
      embeddingDesignation: 'dashboard.campaign_metrics',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CSAT_REPORTS.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          path: 'csat',
          name: 'csat_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: CsatResponses,
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'CSAT_REPORTS.HEADER',
      icon: 'emoji',
      path: 'csat-omni',
      name: 'omni_csat_report',
      embeddingDesignation: 'dashboard.csat',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'BOT_REPORTS.HEADER',
        icon: 'bot',
        keepAlive: false,
      },
      children: [
        {
          path: 'bot',
          name: 'bot_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: BotReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent',
          name: 'agent_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AgentReports,
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'AGENT_REPORTS.HEADER',
      icon: 'people',
      path: 'agents-omni',
      name: 'omni_agents_report',
      embeddingDesignation: 'dashboard.agents',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: LabelReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: InboxReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: TeamReports,
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'TEAM_REPORTS.HEADER',
      icon: 'people-team',
      path: 'teams-omni',
      name: 'omni_teams_report',
      embeddingDesignation: 'dashboard.teams',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TICKET_METRICS_REPORTS.HEADER',
        icon: 'arrow-download',
        keepAlive: false,
      },
      children: [
        {
          path: 'ticket_metrics',
          name: 'ticket_metrics_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: TicketMetricsReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SLA_REPORTS.HEADER',
        icon: 'document-list-clock',
        keepAlive: false,
      },
      children: [
        {
          path: 'sla',
          name: 'sla_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: SLAReports,
        },
      ],
    },
    omniReportRoute({
      headerTitle: 'SLA_POLICIES_REPORTS.HEADER',
      icon: 'document-list-clock',
      path: 'sla-policies-omni',
      name: 'omni_sla_policies_report',
      embeddingDesignation: 'dashboard.sla_policies',
    }),
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'team-view',
          name: 'reports_team_view',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Dashboard,
          props: { embeddingDesignation: 'dashboard.team_view' },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent-view',
          name: 'reports_agent_view',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Dashboard,
          props: { embeddingDesignation: 'dashboard.agent_view' },
        },
      ],
    },

    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT_BUILDER.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: 'report-builder',
          name: 'reports_report_builder',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: ReportBuilder,
          props: { reportType: 'report_builder' },
        },
      ],
    },

    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CREATE_MODE.HEADER',
        icon: 'graph-alt-2',
        keepAlive: false,
      },
      children: [
        {
          path: 'create-mode',
          name: 'reports_create_mode',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: NewCreateModeReport,
        },
      ],
    },
  ],
};
